import { memo } from 'react'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Checkbox from 'components/Checkbox'
import Image from 'components/Image'

import IconDefaultImage from 'assets/icons/IconDefaultImage.svg'
import { ReactComponent as IconModifier } from 'assets/icons/IconModifier.svg'
import useIsItemModifier from 'hooks/useIsItemModifier'
import useFetchImages from 'hooks/useFetchImages'
import { createItemImageLink } from 'utils/links'
import { getItemImage } from 'store/Items/selector'

const Item = memo(
  ({
    item,
    handleSelectItem,
    checked,
    orgName,
    updatedResourceUuid,
  }) => {
    const history = useHistory()

    const availabilityOptions = {
      available: 'Available',
      low_on_inventory: 'Low On Inventory',
      unavailable: 'Unavailable',
    }

    const { images, loading } = useFetchImages(
      createItemImageLink([item?.productSku], orgName)
    )

    const optimisiticImage = useSelector((state) =>
      getItemImage(state, item?.productSku)
    )

    const {
      uuid,
      name,
      price,
      productSku,
      inventoryState,
      itemCategoryUuids,
    } = item

    const itemStateOnInventoryFormatted =
      availabilityOptions[inventoryState]
    const convertToNumberPrice = Number(price)
    const itemClassNames = cn('item', {
      '-selected': checked,
    })

    const isModifier = useIsItemModifier(itemCategoryUuids)

    const image = images?.[productSku] ?? null
    const itemImage =
      updatedResourceUuid === item?.uuid
        ? optimisiticImage
        : images?.[item?.productSku]

    return (
      <div className={itemClassNames}>
        <Checkbox
          checked={checked}
          onChange={() => handleSelectItem(checked, uuid)}
        />
        <div
          className="row"
          onClick={() => {
            history.push({ state: { itemUuid: uuid } })
          }}
        >
          <div className="item-info-wrapper">
            <span className="name font-weight-bold d-flex align-items-center justify-content-space-between w-100">
              <span>{name}</span>
              <span className="d-flex padding-bottom-smalest margin-left-xs margin-right-base">
                {isModifier && <IconModifier />}
              </span>
            </span>
          </div>
          <div className="item-info-wrapper">
            <div className="item__image">
              <Image
                src={`${URL.createObjectURL(
                  itemImage ?? new Blob()
                )}`}
                isImage={image}
                alt={`item-${name}`}
                isLoading={loading}
                fallbackImageSrc={IconDefaultImage}
                fallbackImageAlt={`empty item-${name}`}
              />
            </div>
          </div>
          <div className="item-info-wrapper">
            {convertToNumberPrice.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </div>
          <div className="item-info-wrapper">{productSku}</div>
          <div className="item-info-wrapper">
            <span
              className={cn({
                'item-info-wrapper__available':
                  inventoryState === 'available',
                'item-info-wrapper__low':
                  inventoryState === 'low_on_inventory',
                'item-info-wrapper__unavailable':
                  inventoryState === 'unavailable',
              })}
            ></span>
            {itemStateOnInventoryFormatted}
          </div>
        </div>
      </div>
    )
  }
)

export default Item
